import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { AppLauncher } from "./AppLauncher.js";
import { SwapIcon } from "./icons.js";
import { useAppShell } from "./ShellContext.js";
const WorkspaceSwitcher = React.forwardRef(function WorkspaceSwitcher2({
  label,
  icon,
  apps,
  current,
  hideWhenEmpty = true,
  open,
  defaultOpen,
  onOpenChange,
  launcherTitle,
  launcherProps,
  className,
  ...rest
}, ref) {
  const shell = useAppShell();
  if (hideWhenEmpty && apps.length === 0) return null;
  const trigger = /* @__PURE__ */ jsxs("button", { ref, type: "button", className: cx("ev-nav-item", "ev-workspace-switcher", className), ...rest, children: [
    /* @__PURE__ */ jsx("span", { className: "ev-nav-item__icon", "aria-hidden": "true", children: icon ?? /* @__PURE__ */ jsx(SwapIcon, {}) }),
    /* @__PURE__ */ jsx("span", { className: "ev-nav-item__label", children: label })
  ] });
  return /* @__PURE__ */ jsx(
    AppLauncher,
    {
      ...launcherProps,
      apps,
      current: current ?? shell?.app,
      open,
      defaultOpen,
      onOpenChange,
      title: launcherTitle ?? label,
      trigger
    }
  );
});
export {
  WorkspaceSwitcher
};
//# sourceMappingURL=WorkspaceSwitcher.js.map
